import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../services/api';
import { LIST_ASSESSMENT_TYPE_REQUEST } from '../actions';
import {
  listAssessmentTypeSuccess,
  listAssessmentTypeError,
} from './actions';

function* listAssessmentType() {
  try {
    const response = yield call(api.get, 'assessment-types');
    yield put(listAssessmentTypeSuccess(response.data.data));
  } catch (error) {
    yield put(listAssessmentTypeError(error));
  }
}

export default function* rootSaga() {
  yield all([takeLatest(LIST_ASSESSMENT_TYPE_REQUEST, listAssessmentType)]);
}
